<template>
  <v-flex xs12 md12 lg12>
    <v-card min-height="225px">
      <v-card-text class="pt-32 pb-32 pl-22 pr-22">
        <h2 class="title mb-32 ml-1 mt-3">Trade engine status</h2>
        <v-layout row wrap>
          <v-flex class="xs12 md12 lg12 pl-10 pr-10">
            <router-link v-if="showSettingsLink" to="/settings">
              Connect an exchange.
            </router-link>
          </v-flex>
          <v-flex v-if="existForShow('Binance')" :class="exchangeCardClass">
            <v-card class="no-shadow fill-height">
              <v-toolbar class="toolbar-head">
                <v-toolbar-title>
                  <img
                    :src="'/img/Binance_logo.svg'"
                    alt="Huobi"
                    width="20"
                    height="20"
                  />
                  <span>Binance</span></v-toolbar-title
                >
              </v-toolbar>
              <div class="round-column full-height">
                <v-flex class="trade-engine pr-24 pl-24">
                  Trade engine: <TradeEngineSwitch exchange="Binance" />
                </v-flex>
                <v-divider class="divider"></v-divider>
                <v-flex
                  v-if="
                    tradeEngineStatus.Binance &&
                      tradeEngineStatus.Binance.status_message
                  "
                >
                  <v-flex class="pa-3 trade-date pr-24 pl-24">{{
                    tradeEngineStatus.Binance.timestamp
                      | formatDate("DD MMM YYYY HH:mm z")
                  }}</v-flex>
                  <v-flex class="pl-3 pr-24 pl-24 pre-formatted trade-message">{{
                      tradeEngineStatus.Binance.status_message
                        | truncate(binance_mess_lenght)
                    }}
                    <p
                      v-if="
                        tradeEngineStatus.Binance.status_message.length >= 400
                      "
                    >
                      <a
                        href="#"
                        @click.prevent="
                          binance_mess_lenght <= 400
                            ? (binance_mess_lenght =
                                tradeEngineStatus.Binance.status_message.length)
                            : (binance_mess_lenght = 400)
                        "
                        >{{
                          binance_mess_lenght <= 400 ? "Show more" : "Show less"
                        }}</a
                      >
                    </p>
                  </v-flex>
                </v-flex>
                <v-flex v-else class="pa-2 trade-message">No status known (yet)</v-flex>
              </div>
            </v-card>
          </v-flex>
          <v-flex v-if="existForShow('Bittrex')" :class="exchangeCardClass">
            <v-card class="no-shadow fill-height">
              <v-toolbar class="toolbar-head">
                <v-toolbar-title>
                  <img
                    :src="'/img/Bittrex_logo.svg'"
                    alt="Huobi"
                    width="20"
                    height="20"
                  />
                  <span>Bittrex</span></v-toolbar-title
                >
              </v-toolbar>
              <div class="round-column full-height">
                <v-flex class="trade-engine pr-24 pl-24">
                  Trade engine: <TradeEngineSwitch exchange="Bittrex" />
                </v-flex>
                <v-divider class="divider"></v-divider>
                <v-flex v-if="tradeEngineStatus.Bittrex && tradeEngineStatus.Bittrex.status_message">
                  <v-flex class="pa-3 trade-date pr-24 pl-24">{{
                    tradeEngineStatus.Bittrex.timestamp
                      | formatDate("DD MMM YYYY HH:mm z")
                  }}</v-flex>
                  <v-flex class="pl-3 pr-24 pl-24 pre-formatted trade-message"
                    >{{
                      tradeEngineStatus.Bittrex.status_message
                        | truncate(bittrex_mess_lenght)
                    }}
                    <p
                      v-if="
                        tradeEngineStatus.Bittrex.status_message.length >= 400
                      "
                    >
                      <a
                        href="#"
                        @click.prevent="
                          bittrex_mess_lenght <= 400
                            ? (bittrex_mess_lenght =
                                tradeEngineStatus.Bittrex.status_message.length)
                            : (bittrex_mess_lenght = 400)
                        "
                        >{{
                          bittrex_mess_lenght <= 400 ? "Show more" : "Show less"
                        }}</a
                      >
                    </p>
                  </v-flex>
                </v-flex>
                <v-flex v-else class="pa-2 trade-message">No status known (yet)</v-flex>
              </div>
            </v-card>
          </v-flex>
          <v-flex v-if="existForShow('Huobi')" :class="exchangeCardClass">
            <v-card class="no-shadow fill-height">
              <v-toolbar class="toolbar-head">
                <v-toolbar-title>
                  <img
                    :src="'/img/Huobi_logo.svg'"
                    alt="Huobi"
                    width="20"
                    height="20"
                  />
                  <span>Huobi</span>
                </v-toolbar-title>
              </v-toolbar>
              <div class="round-column full-height">
                <v-flex class="trade-engine pr-24 pl-24">
                  Trade engine: <TradeEngineSwitch exchange="Huobi" />
                </v-flex>
                <v-divider class="divider"></v-divider>
                <v-flex v-if="tradeEngineStatus.Huobi && tradeEngineStatus.Huobi.status_message">
                  <v-flex class="pa-3 trade-date pr-24 pl-24">{{
                    tradeEngineStatus.Huobi.timestamp
                      | formatDate("DD MMM YYYY HH:mm z")
                  }}</v-flex>
                  <v-flex class="pl-3 pr-24 pl-24 pre-formatted trade-message"
                    >{{
                      tradeEngineStatus.Huobi.status_message
                        | truncate(huobi_mess_lenght)
                    }}
                    <p
                      v-if="
                        tradeEngineStatus.Huobi.status_message && tradeEngineStatus.Huobi.status_message.length >= 400
                      "
                    >
                      <a
                        href="#"
                        @click.prevent="
                          huobi_mess_lenght <= 400
                            ? (huobi_mess_lenght =
                                tradeEngineStatus.Huobi.status_message.length)
                            : (huobi_mess_lenght = 400)
                        "
                        >{{
                          huobi_mess_lenght <= 400 ? "Show more" : "Show less"
                        }}</a
                      >
                    </p>
                  </v-flex>
                </v-flex>
                <v-flex v-else class="pa-2 trade-message">No status known (yet)</v-flex>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import TradeEngineSwitch from "../settings/TradeEngineSwitch";

export default {
  components: {
    TradeEngineSwitch
  },
  data: function() {
    return {
      binance_mess_lenght: 400,
      bittrex_mess_lenght: 400,
      huobi_mess_lenght: 400,
      tradeEngineStatus: []
    };
  },

  created: async function() {
    axios.get("/api/v1/settings/trade-engine-status").then(res => {
      this.tradeEngineStatus = res.data;
    });
  },
  computed: {
    ...mapGetters({
      user: "auth/user"
    }),
    showSettingsLink() {
      return this.user ? this.user.exchanges_for_show.length == 0 : true;
    },
    exchangeCardClass: function() {
      switch (this.user.exchanges_for_show.length) {
        case 1:
          return "xs12 md12 lg12 pl-10 pr-10";
        case 2:
          return "xs12 md6 lg6 pl-10 pr-10";
        case 3:
          return "xs12 md4 lg4 pl-10 pr-10";
        default:
          return "";
      }
    }
  },
  methods: {
    existForShow(exchange) {
      return !!this.user.exchanges_for_show.includes(exchange);
    }
  }
};
</script>

<style scoped>
.pre-formatted {
  white-space: pre-wrap; /* css-3 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
}
.theme--light .trade-message {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #103a84;
}
.theme--dark .trade-message {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #ffffff;
}
.theme--light .v-toolbar__title span {
  background: -webkit-linear-gradient(#468aff, #0051dd);
  background-clip: border-box;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 26px;
}
.v-toolbar__title img {
  margin-right: 12px;
}
.theme--light.toolbar-head {
  background: #e6efff;
  border-radius: 10px;
  box-shadow: none !important;
}
.no-shadow {
  box-shadow: none !important;
}
.list-body {
  border: 1px solid #e6efff;
  box-sizing: border-box;
  border-radius: 10px;
}
.no-background {
  background: transparent;
}
.theme--light .round-column {
  border: 1px solid #e6efff;
  box-sizing: border-box;
  border-radius: 10px;
  margin-top: 4px;
}

.theme--dark .v-toolbar__title span {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 26px;
}
.theme--dark .round-column {
  border: 1px solid #303030;
  box-sizing: border-box;
  border-radius: 10px;
  margin-top: 4px;
}
>>> .theme--light .trade-engine {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #7395d0;
  margin-top: 24px;
}
>>> .theme--dark .trade-engine {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: rgba(235, 235, 245, 0.6);
  margin-top: 24px;
}
>>> .theme--light.v-label {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #103a84;
}
>>> .theme--dark.v-toolbar {
  border-color: #424242;
  box-shadow: none;
  background: #303030;
  border-radius: 10px;
}
.theme--light .trade-date {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #7395d0;
}
.theme--dark .trade-date {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: rgba(235, 235, 245, 0.6);
}
.theme--light .divider {
  border-color: #e6efff;
}
.fill-height {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.full-height {
  height: 100%;
}
.pl-24 {
  padding-left: 24px !important;
}
.pr-24 {
  padding-right: 24px !important;
}
.pa-32 {
  padding: 32px;
}
.pa-32 {
  padding: 32px !important;
}
.pt-32 {
  padding-top: 32px;
}
.pb-32 {
  padding-bottom: 32px;
}
.mb-32 {
  margin-bottom: 32px;
}
.pr-10 {
  padding-right: 10px !important;
}
.pl-10 {
  padding-left: 10px !important;
}
.pl-22 {
  padding-left: 22px !important;
}
.pr-22 {
  padding-right: 22px !important;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/dashboard/TradeEngineStatus.vue